import { render } from "./NotificationComponent.vue?vue&type=template&id=429a7890&scoped=true"
import script from "./NotificationComponent.vue?vue&type=script&lang=js"
export * from "./NotificationComponent.vue?vue&type=script&lang=js"

import "./NotificationComponent.vue?vue&type=style&index=0&id=429a7890&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429a7890"]])

export default __exports__